import React from "react";

const Messenger = () => {
  return <div>Messenger</div>;
};

export default Messenger;
